<div class="availability-wrapper">
    <div class="row p-20 align-items-center f-w-600">
        <div class="col-sm-5">{{ 'LABEL.WEEKS' | translate }}</div>
        <div class="col-sm-6">{{ 'LABEL.TIMEING' | translate }}</div>
        <div class="col-sm-1 align-items-end"></div>
    </div>

    <div class="row m-t-12 f-s-12" *ngFor="let item of weeks;let i=index" style="border-bottom: 1px solid gray;">
        <mat-divider />
        <div class="col-sm-3">
            <mat-checkbox color="primary" [(ngModel)]="item.isChecked"
                (click)="setSelectedWeek(i,$event)"></mat-checkbox>
            {{item.day}}
        </div>

        <div class="col-sm-6">
            <ng-container *ngIf="item.isChecked; else unavailableTemplate">
                <div *ngFor="let slot of item.slots; let j = index"
                    class="d-flex align-items-center justify-content-center m-b-16">
                    <mat-form-field appearance="outline" style="width: 150px;" class="hide-hint">
                        <input matInput [matTimepicker]="minutesPicker" [(ngModel)]="slot.startTime"
                            (ngModelChange)="onTimepickerChange($event, slot,'start')" required #startTimeRef="ngModel">
                        <mat-timepicker-toggle matIconSuffix [for]="minutesPicker" />
                        <mat-timepicker interval="10min" #minutesPicker />
                        <mat-error *ngIf="startTimeRef.invalid && startTimeRef.touched">
                            Start time is required
                        </mat-error>
                    </mat-form-field>

                    <span class="me-2 f-w-900"> - </span>
                    <mat-form-field appearance="outline" style="width: 150px;" class="hide-hint">
                        <input matInput [matTimepicker]="minutesPickerend" [(ngModel)]="slot.endTime"
                            (ngModelChange)="onTimepickerChange($event, slot,'end')">
                        <mat-timepicker-toggle matIconSuffix [for]="minutesPickerend" />
                        <mat-timepicker interval="10min" #minutesPickerend />
                    </mat-form-field>

                    <a class="m-l-10 cursor-pointer justify-content-center" (click)="removeSlot(i, j)">
                        <i-tabler name="trash" class="icon-20"></i-tabler>
                    </a>
                </div>
            </ng-container>
            <ng-template #unavailableTemplate>
                <div class="text-center" style="color: gray;">
                    <h3>{{ 'LABEL.UNAVALABLE_LABEL' | translate }}</h3>
                </div>
            </ng-template>
        </div>

        <div class="col-sm-3 d-flex justify-content-end">
            <a class="m-r-10 cursor-pointer" (click)="addSlot(i)">
                <i-tabler matTooltip="Add Slot" name="plus" class="icon-18"></i-tabler>
            </a>
            <a class="m-r-10 cursor-pointer" [matMenuTriggerFor]="copytime">
                <i-tabler matTooltip="Copy Slot" name="copy" class="icon-18"></i-tabler>
            </a>
            <mat-menu #copytime>
                <div class="m-10" *ngFor="let week of weeks;let i=index">
                    <mat-checkbox color="primary" style="font-size: 15px;" (click)="setSelectedWeek(i,$event)"
                        [checked]="selectedWeeks.includes(i)">
                    </mat-checkbox>
                    {{ week.day }}
                </div>
                <div>
                    <button mat-raised-button class="m-l-10 m-r-10" style="width: 150px;" (click)="applyCopyTime(i)"
                        color="primary">{{ 'BUTTON.BTN_APPLY' | translate }}
                    </button>
                </div>
            </mat-menu>
        </div>

    </div>
    <div class="text-right m-t-20 m-b-20" *ngIf="isDoctor">
        <button mat-flat-button color="primary" class="m-l-7" (click)="updateSlot()">
            {{ 'BUTTON.BTN_SAVE' | translate }}</button>
    </div>
</div>